import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { DeclarationDocumentsEnum } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export enum MutateDeclarationDocumentOperation {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

interface HookProps {
  doc: {
    operation: MutateDeclarationDocumentOperation;
    type: DeclarationDocumentsEnum;
    id: Record<string, string>;
    data?: any;
  };
  lrn: string;
  sequence: number;
}

export const useUpdateDeclarationDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ doc, lrn, sequence }: HookProps) => {
      const body = { document: doc, lrn, sequence };

      const result =
        doc.operation === MutateDeclarationDocumentOperation.CREATE
          ? await apiClient.declarationsDocuments.createDocument.mutation({ body })
          : doc.operation === MutateDeclarationDocumentOperation.UPDATE
            ? await apiClient.declarationsDocuments.updateDocument.mutation({ body })
            : await apiClient.declarationsDocuments.deleteDocument.mutation({ body });

      if (result.status !== 200) throw result.body;

      return result.body.data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', data._id] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
